export const ICON_ROOT_PATH = `${process.env.NEXT_PUBLIC_DEPLOY_URL}/icons`;
export const IconNames = [
    'check-filled',
    'error-filled',
    'farm',
    'female',
    'group',
    'male',
    'nation-flag',
    'pin-inactive',
    'pin-selected',
    'pin',
    'plus',
    'tracing',
];
export const SizeRecord = {
    'x-small': 10,
    small: 12,
    medium: 14,
    large: 16,
    'x-large': 28,
    'xx-large': 32,
    'xxx-large': 40,
};
export const getIconColor = (color, theme) => {
    const ColorRecord = {
        yellow: theme.palette.primary.main,
        'gray-40': theme.palette.grey['A500'],
        'gray-100': theme.palette.grey['A800'],
        green: theme.palette.success.main,
        white: '#fff',
    };
    if (Object.keys(ColorRecord).includes(color)) {
        return ColorRecord[color];
    }
    return color;
};
